import { InputType } from './checklist.model';
import { EvaluationStatus } from './evaluation.model';
import { ImmutableMap, QueryParams } from './utility.model';

export type ResultFile = {
  fileId: string;
  name: string;
  decryptionKey: string;
  upload: string;
};
export type ResultImageFile = ResultFile & { evaluation?: Evaluation; evaluationStatus?: EvaluationStatus };

type ResultProvidedProps = {
  unitId: string;
  resultId: string;
  organizationId: string;
  itemId: string;
  title: string;
  body: string;
  type: string;
  segment: string;
  inputType: InputType;
  logicalName?: string;
  resultType: string;
  report: boolean;
  photo: boolean;
  evaluationId: string;
  result: string;
  resultInputType: InputType;
  startedAt: number;
  stoppedAt: number;
  userId: string;
  userName: string;
  skip: string;
  redo: string;
  prev: string;
  videos: ResultFile[];
  voices: ResultFile[];
  images: ResultImageFile[];
  editor: string;
  editorName: string;
  updatedAt: number;
  version: number;
};

export type ResultQueryParams = QueryParams & { projectId: string; unitId: string };

export type FileQueryParams = QueryParams & { projectId: string; unitId: string; resultId: string; fileId: string };

export type Result = ResultProvidedProps;

export type ResultWithLatest = Result & { isLatest: boolean };

export type ResultWithLatestAndFileInfo = ResultWithLatest & {
  uploadStatus: {
    video: UploadStatus;
    voice: UploadStatus;
    image: UploadStatus;
  };
  evaluation: {
    image: EvaluationWithEmpty;
  };
  show: {
    datetime: boolean;
    userName: boolean;
    result: boolean;
  };
};

export type UploadStatus = 'none' | 'in-progress' | 'failed' | 'succeed';

export type Evaluation = 'none' | 'in-progress' | 'failed' | 'completed';
export type EvaluationWithEmpty = Evaluation | 'empty';

export class Results extends ImmutableMap<string, Result> {
  constructor(results?: Result[] | Iterable<Result>) {
    super((result: Result) => result.resultId, results);
  }

  protected clone(results?: Result[] | Iterable<Result>): this {
    return new Results(results) as this;
  }
}
